
let THREE,GLTFLoader,RoomEnvironment,MeshoptDecoder;
window.__initPatch3D=async function(){
if(window.__p3dStarted)return;window.__p3dStarted=true;
THREE=await import('three');
({GLTFLoader}=await import('three/addons/loaders/GLTFLoader.js'));
({RoomEnvironment}=await import('three/addons/environments/RoomEnvironment.js'));
({MeshoptDecoder}=await import('three/addons/libs/meshopt_decoder.module.js'));

const $=s=>document.querySelector(s);
const bar=$('#bar i'),status=$('#status');
const prog=(p,t)=>{bar.style.width=p+'%';status.textContent=t;};
const fail=m=>{$('#bar').style.display='none';status.style.display='none';const e=$('#err');e.style.display='block';e.textContent=m;};
const CFG=window.__rig={view:'x+',centerY:.57,frameFrac:.535,yawDeg:0,oscDeg:8,period:16,rotMinDeg:-24,rotMaxDeg:17,exposure:1.12,amb:.1,spot:3};
const K=window.__knife={px:.25,py:-.085,pz:.13,ry:354,cant:3,scale:.42};
const P=window.__patch={mode:'emb',y:.59,pz:-.01,size:.195,lift:.008,thick:.01,embBump:1.1,pvcBump:.6};
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const stall=setTimeout(()=>{if(!document.body.classList.contains('ready'))fail('Stalled at "'+status.textContent+'". Needs internet for the 3D library; try Chrome.');},40000);
try{
const canvas=$('#stage');
const renderer=new THREE.WebGLRenderer({canvas,antialias:true,alpha:true});
renderer.setPixelRatio(Math.min(devicePixelRatio,2));
renderer.toneMapping=THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure=CFG.exposure;
const scene=new THREE.Scene();
scene.environment=new THREE.PMREMGenerator(renderer).fromScene(new RoomEnvironment(),.04).texture;
const cam=new THREE.PerspectiveCamera(30,1,.01,100);
const rig=new THREE.Group();scene.add(rig);
const loader=new GLTFLoader();loader.setMeshoptDecoder(MeshoptDecoder);
const ASSETS=window.PATCH_ASSETS||{};
async function parseUrl(url,label,pct){
  prog(pct,label);
  const r=await fetch(url);
  if(!r.ok)throw new Error('Could not fetch '+label+' ('+r.status+')');
  const buf=await r.arrayBuffer();
  return await new Promise((res,rej)=>loader.parse(buf,'',res,rej));
}
const vestG=await parseUrl(ASSETS.vest,'LOADING CARRIER',18);
const model=vestG.scene;rig.add(model);
const box=new THREE.Box3().setFromObject(model);
const center=box.getCenter(new THREE.Vector3());
const sphere=box.getBoundingSphere(new THREE.Sphere());
const sizeY=box.max.y-box.min.y;
model.position.sub(center);
const maxAniso=renderer.capabilities.getMaxAnisotropy();
model.traverse(o=>{if(o.isMesh&&o.material){if(o.material.map)o.material.map.anisotropy=maxAniso;o.material.envMapIntensity=.9;}});

const knifeG=await parseUrl(ASSETS.knife,'LOADING KNIFE',48);
const knifeInner=new THREE.Group(),knifeRig=new THREE.Group();
const kScene=knifeG.scene;
const kbox=new THREE.Box3().setFromObject(kScene);
const kc=kbox.getCenter(new THREE.Vector3());
const kh=kbox.max.y-kbox.min.y;
kScene.position.sub(kc);
kScene.traverse(o=>{if(o.isMesh&&o.material){if(o.material.map)o.material.map.anisotropy=maxAniso;o.material.envMapIntensity=.9;}});
knifeInner.add(kScene);knifeRig.add(knifeInner);rig.add(knifeRig);
function applyKnife(){
  const s=K.scale*sizeY/kh;
  knifeInner.scale.setScalar(s);
  knifeRig.position.set(K.px,K.py,K.pz);
  knifeRig.rotation.set(0,THREE.MathUtils.degToRad(K.ry),THREE.MathUtils.degToRad(K.cant));
  const out=document.getElementById('krd');
  if(out)out.value=JSON.stringify({px:+K.px.toFixed(3),py:+K.py.toFixed(3),pz:+K.pz.toFixed(3),ry:Math.round(K.ry),cant:Math.round(K.cant),scale:+K.scale.toFixed(3)});
}
window.__applyKnife=applyKnife;applyKnife();

prog(66,'PREPARING PATCH');
function urlToImg(url){return new Promise((res,rej)=>{if(!url){res(null);return;}
  const im=new Image();im.crossOrigin='anonymous';im.onload=()=>res(im);im.onerror=rej;im.src=url;});}
const patchImgs={emb:await urlToImg(ASSETS.emb),pvc:await urlToImg(ASSETS.pvc)};
const havePatches=!!(patchImgs.emb||patchImgs.pvc);
['emb','pvc'].forEach(k2=>{const sw=document.getElementById('sw-'+k2);if(sw&&patchImgs[k2])sw.style.backgroundImage='url('+patchImgs[k2].src+')';});

function buildMaps(img,mode){
  const W=512;
  const src=document.createElement('canvas');src.width=src.height=W;
  const sx=src.getContext('2d');sx.drawImage(img,0,0,W,W);
  const data=sx.getImageData(0,0,W,W).data;
  let hasAlpha=false;
  for(let i=3;i<data.length;i+=4){if(data[i]<250){hasAlpha=true;break;}}
  let E=null;
  if(hasAlpha){
    const ac=document.createElement('canvas');ac.width=ac.height=W;
    const actx=ac.getContext('2d');const aid=actx.createImageData(W,W);
    for(let i=0;i<W*W;i++){const a=data[i*4+3];aid.data[i*4]=aid.data[i*4+1]=aid.data[i*4+2]=a;aid.data[i*4+3]=255;}
    actx.putImageData(aid,0,0);
    const bc=document.createElement('canvas');bc.width=bc.height=W;
    const bctx=bc.getContext('2d');bctx.filter='blur(6px)';bctx.drawImage(ac,0,0);
    E=bctx.getImageData(0,0,W,W).data;
  }
  const R=W*0.492;
  const disp=document.createElement('canvas');disp.width=disp.height=W;
  const dx=disp.getContext('2d');const dd=dx.createImageData(W,W);
  const lum=document.createElement('canvas');lum.width=lum.height=W;
  const lx=lum.getContext('2d');const ld=lx.createImageData(W,W);
  const alpha=document.createElement('canvas');alpha.width=alpha.height=W;
  const ax=alpha.getContext('2d');
  for(let j=0;j<W;j++)for(let i=0;i<W;i++){
    const idx=j*W+i,k=idx*4;
    const L=(0.2126*data[k]+0.7152*data[k+1]+0.0722*data[k+2])/255;
    let edge;
    if(hasAlpha){
      edge=Math.min(1,(E[k]/255)*1.12);
      if(data[k+3]<40)edge=0;
    }else{
      const r=Math.hypot(i-W/2+.5,j-W/2+.5);
      edge=0;
      if(r<=R){const t=Math.min(1,(R-r)/(R*0.09));edge=Math.sin(t*Math.PI/2);}
    }
    let hgt;
    if(mode==='pvc'){hgt=L>0.55?1:(L>0.16?0.52:0.4);}
    else{hgt=0.4+0.6*L;}
    const dv=Math.round(255*hgt*edge);
    dd.data[k]=dd.data[k+1]=dd.data[k+2]=dv;dd.data[k+3]=255;
    const lv=Math.round(255*L);
    ld.data[k]=ld.data[k+1]=ld.data[k+2]=lv;ld.data[k+3]=255;
  }
  dx.putImageData(dd,0,0);
  lx.putImageData(ld,0,0);
  if(mode==='pvc'){const tmp=document.createElement('canvas');tmp.width=tmp.height=W;const tx=tmp.getContext('2d');
    tx.filter='blur(2.2px)';tx.drawImage(disp,0,0);dx.clearRect(0,0,W,W);dx.drawImage(tmp,0,0);}
  if(hasAlpha){
    const aid2=ax.createImageData(W,W);
    for(let i=0;i<W*W;i++){const a=data[i*4+3];aid2.data[i*4]=aid2.data[i*4+1]=aid2.data[i*4+2]=a;aid2.data[i*4+3]=255;}
    ax.putImageData(aid2,0,0);
  }else{
    ax.fillStyle='#000';ax.fillRect(0,0,W,W);
    ax.fillStyle='#fff';ax.beginPath();ax.arc(W/2,W/2,R-1,0,Math.PI*2);ax.fill();
  }
  let rr=0,rg=0,rb=0,rc=0;
  const radCount=new Array(W).fill(0);
  for(let j=0;j<W;j++)for(let i=0;i<W;i++){
    const k=(j*W+i)*4;
    const r=Math.hypot(i-W/2+.5,j-W/2+.5);
    if(hasAlpha&&data[k+3]>128)radCount[Math.min(W-1,Math.round(r))]++;
    const inRing=hasAlpha?(data[k+3]>200&&r>R*.88):(r>R*.88&&r<=R);
    if(inRing){rr+=data[k];rg+=data[k+1];rb+=data[k+2];rc++;}
  }
  const rim=rc?[rr/rc,rg/rc,rb/rc]:[220,220,220];
  let alphaR=0.492;
  if(hasAlpha){
    for(let b=Math.floor(W*.55);b>=0;b--){
      if(radCount[b]>8){alphaR=(b+1)/W;break;}
    }
  }
  const t1=new THREE.CanvasTexture(disp);
  const t2=new THREE.CanvasTexture(lum);
  const t3=new THREE.CanvasTexture(alpha);
  const cm=new THREE.Texture(img);cm.needsUpdate=true;cm.colorSpace=THREE.SRGBColorSpace;cm.anisotropy=maxAniso;
  return{disp:t1,lum:t2,alpha:t3,color:cm,rim:rim,alphaR:alphaR};
}
const mapCache={};
function mapsFor(mode){const img=patchImgs[mode];if(!img)return null;
  if(!mapCache[mode])mapCache[mode]=buildMaps(img,mode);return mapCache[mode];}

let patchMesh=null;
function mountPatch(){
  if(patchMesh){rig.remove(patchMesh);patchMesh.traverse(o=>{if(o.geometry)o.geometry.dispose();});patchMesh=null;}
  if(!havePatches||P.mode==='none'){syncPatchUI();return;}
  const maps=mapsFor(P.mode)||mapsFor('emb')||mapsFor('pvc');
  if(!maps){syncPatchUI();return;}
  const prevRot=rig.rotation.y;
  rig.rotation.y=0;rig.updateMatrixWorld(true);
  const latExt=box.max.z-box.min.z;
  const dia=P.size*latExt;
  const T=P.thick*sizeY;
  const slabH=T*.45,reliefH=T*.55;
  const isPvc=P.mode==='pvc';
  const grp=new THREE.Group();
  const rimCol=new THREE.Color(maps.rim[0]/255,maps.rim[1]/255,maps.rim[2]/255).multiplyScalar(.82);
  const slabR=dia*(maps.alphaR||.4975)*.94;
  const slab=new THREE.Mesh(new THREE.CylinderGeometry(slabR,slabR,slabH,96),
    new THREE.MeshStandardMaterial({color:rimCol,roughness:isPvc?.55:.95,metalness:0,envMapIntensity:isPvc?.9:.5}));
  slab.rotation.x=Math.PI/2;slab.position.z=slabH/2;grp.add(slab);
  const geo=new THREE.PlaneGeometry(dia,dia,160,160);
  const mat=new THREE.MeshStandardMaterial({
    map:maps.color,alphaMap:maps.alpha,transparent:true,alphaTest:.45,
    displacementMap:maps.disp,displacementScale:reliefH,displacementBias:slabH*.98,
    bumpMap:maps.lum,bumpScale:isPvc?P.pvcBump:P.embBump,
    roughness:isPvc?.5:.92,metalness:0,envMapIntensity:isPvc?1.0:.55,
    polygonOffset:true,polygonOffsetFactor:-2});
  const front=new THREE.Mesh(geo,mat);grp.add(front);
  const yWorld=box.min.y+P.y*sizeY;
  const origin=new THREE.Vector3(0,yWorld-center.y,P.pz).add(new THREE.Vector3(sphere.radius*2.5,0,0));
  const ray=new THREE.Raycaster(origin,new THREE.Vector3(-1,0,0),.01,sphere.radius*6);
  const hits=ray.intersectObject(model,true);
  let baseX;
  if(hits.length){baseX=hits[0].point.x;}
  else{baseX=box.max.x-center.x;}
  grp.position.set(baseX+P.lift*sizeY,yWorld-center.y,P.pz);
  grp.rotation.y=Math.PI/2;
  spot.position.set(baseX+sphere.radius*1.5,grp.position.y+sphere.radius*.55,P.pz+sphere.radius*.25);
  spot.target.position.copy(grp.position);
  patchMesh=grp;
  rig.add(patchMesh);
  rig.rotation.y=prevRot;rig.updateMatrixWorld(true);
  syncPatchUI();
}
function syncPatchUI(){
  document.querySelectorAll('.ptc-fin').forEach(f=>f.classList.toggle('on',f.dataset.mat===P.mode));
  document.querySelectorAll('.ptc-tab').forEach(t=>{
    const show=t.dataset.side==='l'?(t.dataset.mat==='emb'&&P.mode==='pvc'):(t.dataset.mat==='pvc'&&P.mode==='emb');
    t.classList.toggle('hide',!show);t.tabIndex=show?0:-1;});
  document.querySelectorAll('.ptc-card').forEach(cd=>cd.classList.toggle('on',cd.dataset.mat===P.mode&&!!patchMesh&&patchMesh.visible));
  const out=document.getElementById('prd');
  if(out)out.value=JSON.stringify({mode:P.mode,y:+P.y.toFixed(3),pz:+P.pz.toFixed(3),size:+P.size.toFixed(3),lift:+P.lift.toFixed(4),thick:+P.thick.toFixed(4)});
  const msl2=document.getElementById('ptc-mat-slider');
  if(msl2&&document.activeElement!==msl2)msl2.value=P.mode==='pvc'?1:0;
}
window.__mountPatch=mountPatch;
document.querySelectorAll('.ptc-tab').forEach(t=>t.addEventListener('click',function(){P.mode=this.dataset.mat;mountPatch();}));
const msl=document.getElementById('ptc-mat-slider');
if(msl){
  msl.addEventListener('input',function(){
    const m=parseFloat(this.value)>=.5?'pvc':'emb';
    if(m!==P.mode){P.mode=m;mountPatch();}
  });
  const snap=function(){msl.value=P.mode==='pvc'?1:0;};
  msl.addEventListener('change',snap);
  msl.addEventListener('pointerup',snap);
}
document.querySelectorAll('#ppanel input[type=range]').forEach(sl=>{
  sl.addEventListener('input',function(){
    P[this.dataset.p]=parseFloat(this.value);
    const v=this.parentElement.querySelector('b');if(v)v.textContent=this.value;
    mountPatch();
  });
});
document.querySelectorAll('#fpanel input[type=range]').forEach(sl=>{
  sl.addEventListener('input',function(){
    CFG[this.dataset.f]=parseFloat(this.value);
    const v=this.parentElement.querySelector('b');if(v)v.textContent=this.value;
    frame();applyLights();
    const out=document.getElementById('frd');
    if(out)out.value=JSON.stringify({centerY:+CFG.centerY.toFixed(3),frameFrac:+CFG.frameFrac.toFixed(3),rotMin:Math.round(CFG.rotMinDeg),rotMax:Math.round(CFG.rotMaxDeg),amb:+CFG.amb.toFixed(2),spot:Math.round(CFG.spot)});
  });
});

let AX='x',SGN=1,LAT='z';
function axes(){AX=CFG.view[0];SGN=CFG.view[1]==='+'?1:-1;LAT=AX==='x'?'z':'x';}
const S=()=>{const v=new THREE.Vector3();v[AX]=SGN;return v;};
const key=new THREE.DirectionalLight(0xfff1dc,2.4);scene.add(key);
const rim=new THREE.DirectionalLight(0xcfd8e8,1.0);scene.add(rim);
const hemi=new THREE.HemisphereLight(0x9aa0a8,0x151510,.4);scene.add(hemi);
const spot=new THREE.SpotLight(0xfff3dd,26,0,.32,.7,1);
scene.add(spot);scene.add(spot.target);
function applyLights(){
  key.intensity=2.6*CFG.amb;
  hemi.intensity=.5*CFG.amb;
  rim.intensity=.9*Math.max(CFG.amb,.35);
  spot.intensity=CFG.spot;
}
window.__applyLights=applyLights;
function placeLights(){const s=S(),r=sphere.radius;
  key.position.set(0,0,0).addScaledVector(s,r*2.2);key.position.y+=r*2.0;key.position[LAT]+=r*1.3;
  rim.position.set(0,0,0).addScaledVector(s,-r*2.4);rim.position.y+=r*1.5;rim.position[LAT]-=r*1.1;}
const blobC=document.createElement('canvas');blobC.width=blobC.height=256;
const bx=blobC.getContext('2d');const g=bx.createRadialGradient(128,128,10,128,128,120);
g.addColorStop(0,'rgba(201,168,76,.25)');g.addColorStop(.5,'rgba(0,0,0,.35)');g.addColorStop(1,'rgba(0,0,0,0)');
bx.fillStyle=g;bx.fillRect(0,0,256,256);
const blob=new THREE.Mesh(new THREE.CircleGeometry(sphere.radius*1.15,48),new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(blobC),transparent:true,depthWrite:false}));
blob.rotation.x=-Math.PI/2;blob.position.y=box.min.y-center.y-.002;scene.add(blob);
let base=new THREE.Vector3();
function frame(){
  axes();
  const w=canvas.clientWidth||600,h2=canvas.clientHeight||520;
  renderer.setSize(w,h2,false);cam.aspect=w/h2;
  const target=new THREE.Vector3(0,box.min.y+CFG.centerY*sizeY-center.y,0);
  const fov=THREE.MathUtils.degToRad(cam.fov);
  const dist=(CFG.frameFrac*sizeY/2)/Math.tan(fov/2);
  const dir=S().applyAxisAngle(new THREE.Vector3(0,1,0),THREE.MathUtils.degToRad(CFG.yawDeg));
  cam.position.copy(target).addScaledVector(dir,dist);
  cam.position.y=target.y+sizeY*.02;
  cam.lookAt(target);cam.updateProjectionMatrix();
  base.copy(cam.position);
}
axes();placeLights();applyLights();frame();
mountPatch();
new ResizeObserver(()=>frame()).observe(canvas);
document.querySelectorAll('.ptc-view button').forEach(b=>b.addEventListener('click',function(){
  CFG.view=this.dataset.view;
  document.querySelectorAll('.ptc-view button').forEach(x=>x.classList.toggle('active',x===this));
  axes();placeLights();frame();
}));
document.querySelectorAll('#kpanel input[type=range]').forEach(sl=>{
  sl.addEventListener('input',function(){
    K[this.dataset.k]=parseFloat(this.value);
    const v=this.parentElement.querySelector('b');if(v)v.textContent=this.value;
    applyKnife();
  });
});
let vel=0,mx=0,my=0,drag=false,lastX=0,lastT=performance.now();
canvas.addEventListener('pointerdown',e=>{drag=true;lastX=e.clientX;canvas.classList.add('dragging');canvas.setPointerCapture(e.pointerId);lastT=performance.now();});
const rotMin=()=>THREE.MathUtils.degToRad(CFG.rotMinDeg),rotMax=()=>THREE.MathUtils.degToRad(CFG.rotMaxDeg);
addEventListener('pointermove',e=>{mx=e.clientX/innerWidth*2-1;my=e.clientY/innerHeight*2-1;
  if(drag){vel=THREE.MathUtils.clamp(vel+(e.clientX-lastX)*.005,rotMin(),rotMax());lastX=e.clientX;lastT=performance.now();}});
addEventListener('pointerup',()=>{drag=false;canvas.classList.remove('dragging');});
addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){vel=Math.max(vel-.06,rotMin());lastT=performance.now();}if(e.key==='ArrowRight'){vel=Math.min(vel+.06,rotMax());lastT=performance.now();}});
const clock=new THREE.Clock();let idle=reduce?0:1;
renderer.setAnimationLoop(()=>{
  const t=clock.getElapsedTime();
  const idleT=performance.now()-lastT>2500;
  idle+=((reduce?0:idleT&&!drag?1:0)-idle)*.04;
  const osc=Math.sin(t*Math.PI*2/CFG.period)*THREE.MathUtils.degToRad(CFG.oscDeg)*idle;
  rig.rotation.y=THREE.MathUtils.clamp(osc+vel,rotMin(),rotMax());
  cam.position.y=base.y;
  renderer.render(scene,cam);
});
window.__dbg={renderer,scene,camera:cam,rig,model,knife:knifeRig,patch:()=>patchMesh,CFG,K,P};
clearTimeout(stall);
prog(100,'READY');
setTimeout(()=>{$('#loader').classList.add('done');document.body.classList.add('ready');},350);
}catch(err){console.error(err);fail('Could not start the 3D scene: '+(err&&err.message?err.message:err));}
};

window.__initPin3D=async function(){
if(window.__pin3dStarted)return;window.__pin3dStarted=true;
const T=await import('three');
const {GLTFLoader:PGL}=await import('three/addons/loaders/GLTFLoader.js');
const {MeshoptDecoder:PMD}=await import('three/addons/libs/meshopt_decoder.module.js');
const pane=document.getElementById('pane-pins');if(!pane)return;
pane.innerHTML='<style>'+
'.pin3d-stage{display:grid;grid-template-columns:minmax(190px,1fr) auto minmax(190px,1fr);align-items:center;gap:clamp(10px,2vw,24px);max-width:1100px;margin:0 auto}'+
'.pin3d-col{display:flex;flex-direction:column;align-self:stretch;justify-content:space-between;padding:56px 0 84px}'+
'.pin3d-card{position:relative;max-width:250px;padding:15px 17px;opacity:0;transform:translateY(6px);transition:opacity .6s ease var(--d,0s),transform .6s ease var(--d,0s);--arm:clamp(26px,4.5vw,74px)}'+
'.pin3d-col-l .pin3d-card{align-self:flex-end;text-align:right}'+
'.pin3d-col-r .pin3d-card{align-self:flex-start}'+
'.pin3d-card h4{font-family:"Barlow Condensed",sans-serif;font-weight:600;font-size:12.5px;letter-spacing:.22em;text-transform:uppercase;color:#C9A84C;margin:0 0 6px}'+
'.pin3d-card p{font-family:"Barlow",sans-serif;font-size:12.5px;line-height:1.6;letter-spacing:.01em;color:#999;margin:0}'+
'.pin3d-card::after{content:"";position:absolute;top:50%;height:1px;width:var(--arm);background:#C9A84C;opacity:.75;transform:scaleX(0);transition:transform .5s ease calc(var(--d,0s) + .15s)}'+
'.pin3d-col-l .pin3d-card::after{left:100%;transform-origin:left center}'+
'.pin3d-col-r .pin3d-card::after{right:100%;transform-origin:right center}'+
'.pin3d-card::before{content:"";position:absolute;top:50%;width:7px;height:7px;margin-top:-3px;border-radius:50%;background:#C9A84C;box-shadow:0 0 8px rgba(201,168,76,.16);opacity:0;transition:opacity .4s ease calc(var(--d,0s) + .35s)}'+
'.pin3d-col-l .pin3d-card::before{left:calc(100% + var(--arm) - 3px)}'+
'.pin3d-col-r .pin3d-card::before{right:calc(100% + var(--arm) - 3px)}'+
'.pin3d-on .pin3d-card{opacity:1;transform:none}'+
'.pin3d-on .pin3d-card::after{transform:scaleX(1)}'+
'.pin3d-on .pin3d-card::before{opacity:1}'+
'.pin3d-wrap{position:relative;width:min(600px,88vw);aspect-ratio:1.5;margin:0 auto}'+
'.pin3d-wrap canvas{width:100%;height:100%;display:block;cursor:grab;touch-action:pan-y}'+
'.pin3d-wrap canvas.dragging{cursor:grabbing}'+
'.pin3d-load{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;transition:opacity .5s}'+
'.pin3d-load.done{opacity:0;pointer-events:none}'+
'.pin3d-wm{font-family:Helvetica,Arial,sans-serif;font-weight:700;font-size:20px;color:#F5F3EE;opacity:.85}'+
'.pin3d-bar{width:150px;height:2px;background:rgba(255,255,255,.12);overflow:hidden}'+
'.pin3d-bar i{display:block;height:100%;width:0;background:#C9A84C;transition:width .3s}'+
'.pin3d-status{font-family:"Barlow Condensed",sans-serif;font-size:10px;letter-spacing:.3em;color:#8a7434;text-transform:uppercase}'+
'.pin3d-err{display:none;color:#c66;font:12px/1.5 "Barlow",sans-serif;max-width:80%;text-align:center}'+
'.pin3d-hint{text-align:center;font-family:"Barlow Condensed",sans-serif;font-size:11px;letter-spacing:.28em;text-transform:uppercase;color:#666;margin-top:14px}'+
'@media(max-width:860px){.pin3d-stage{grid-template-columns:1fr}.pin3d-col{flex-direction:row;justify-content:center;gap:14px;padding:16px 0 0}.pin3d-card{max-width:46%}.pin3d-card::after,.pin3d-card::before{display:none}.pin3d-col-l .pin3d-card{text-align:left;align-self:auto}.pin3d-col-r .pin3d-card{align-self:auto}.pin3d-col-l{order:2}.pin3d-center{order:1}.pin3d-col-r{order:3}}'+
'</style>'+
'<div class="pin3d-stage">'+
'<div class="pin3d-col pin3d-col-l">'+
'<div class="pin3d-card" style="--d:.15s"><h4>Polished Metal</h4><p>Die-struck brass, hand-buffed to a jewelry shine. Plating that reads premium at arm\'s length.</p></div>'+
'<div class="pin3d-card" style="--d:.45s"><h4>Years Of Wear</h4><p>Made for daily uniform wear. No fade, no tarnish, no chipped color.</p></div>'+
'</div>'+
'<div class="pin3d-center">'+
'<div class="pin3d-wrap"><canvas></canvas><div class="pin3d-load"><div class="pin3d-wm">In-service</div><div class="pin3d-bar"><i></i></div><div class="pin3d-status">DECODING PIN</div><div class="pin3d-err"></div></div></div>'+
'<div class="pin3d-hint">&#9666; drag the pin &#9656;</div>'+
'</div>'+
'<div class="pin3d-col pin3d-col-r">'+
'<div class="pin3d-card" style="--d:.3s"><h4>Enamel Dome</h4><p>A clear dome seals the enamel glass-smooth and dead flat over the metal lines.</p></div>'+
'<div class="pin3d-card" style="--d:.6s"><h4>Double Clutch</h4><p>Two-post backing keeps the pin aligned and upright. It never spins on the uniform.</p></div>'+
'</div>'+
'</div>';
const canvas=pane.querySelector('canvas'),loadEl=pane.querySelector('.pin3d-load');
const bar=pane.querySelector('.pin3d-bar i'),statusEl=pane.querySelector('.pin3d-status'),errEl=pane.querySelector('.pin3d-err');
const prog=(p,t)=>{bar.style.width=p+'%';statusEl.textContent=t;};
const fail=m=>{pane.querySelector('.pin3d-bar').style.display='none';statusEl.style.display='none';errEl.style.display='block';errEl.textContent=m;};
const L={keyAz:0,keyEl:40,keySize:1.2,keyPow:5,env:1.2,spot:2.4,amb:0.88,exposure:1.16,rotMin:-24,rotMax:17,oscDeg:8,period:16};
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const stall=setTimeout(()=>{if(!loadEl.classList.contains('done'))fail('Stalled at "'+statusEl.textContent+'". Needs internet for the 3D library; try Chrome.');},40000);
try{
const renderer=new T.WebGLRenderer({canvas,antialias:true,alpha:true});
renderer.setPixelRatio(Math.min(devicePixelRatio,2));
renderer.toneMapping=T.ACESFilmicToneMapping;
renderer.toneMappingExposure=L.exposure;
renderer.outputColorSpace=T.SRGBColorSpace;
const scene=new T.Scene();
const pmrem=new T.PMREMGenerator(renderer);
const cv=document.createElement('canvas');cv.width=cv.height=256;
const c2=cv.getContext('2d');
const gg=c2.createRadialGradient(128,128,14,128,128,130);
gg.addColorStop(0,'#ffffff');gg.addColorStop(0.55,'#b9b9b9');gg.addColorStop(1,'#000000');
c2.fillStyle=gg;c2.fillRect(0,0,256,256);
const gradT=new T.CanvasTexture(cv);
const es=new T.Scene();es.background=new T.Color(0x000000);
const mk=(w,h,p,warm)=>{const m=new T.Mesh(new T.PlaneGeometry(w,h),new T.MeshBasicMaterial({map:gradT,color:new T.Color(p,p*(warm?0.96:1),p*(warm?0.88:1))}));es.add(m);return m;};
const d=2.4,ax=L.keyAz*Math.PI/180,el=L.keyEl*Math.PI/180;
const key=mk(3.4*L.keySize,2.3*L.keySize,L.keyPow,true);
key.position.set(d*Math.cos(el)*Math.cos(ax),d*Math.sin(el),d*Math.cos(el)*Math.sin(ax));key.lookAt(0,0,0);
const strip=mk(1.1,3.4,0.7,false);strip.position.set(-1.4,0.5,-2.1);strip.lookAt(0,0,0);
const bounce=mk(4.5,4.5,0.15,false);bounce.position.set(0.4,-2.6,0);bounce.lookAt(0,0,0);
scene.environment=pmrem.fromScene(es,0.07).texture;
const amb=new T.AmbientLight(0xffffff,L.amb);scene.add(amb);
const spot=new T.SpotLight(0xfff1dd,L.spot);spot.angle=0.6;spot.penumbra=0.6;spot.decay=0;spot.position.set(2.6,1.8,0.9);scene.add(spot);scene.add(spot.target);
const cam=new T.PerspectiveCamera(34,1.5,0.01,50);
const rig=new T.Group();scene.add(rig);
prog(18,'FETCHING PIN');
const A=window.PIN_ASSETS||{};
const r=await fetch(A.pin);
if(!r.ok)throw new Error('Could not fetch pin model ('+r.status+')');
const buf=await r.arrayBuffer();
prog(60,'DECODING PIN');
const loader=new PGL();loader.setMeshoptDecoder(PMD);
const gl=await new Promise((res,rej)=>loader.parse(buf,'',res,rej));
const maxAniso=renderer.capabilities.getMaxAnisotropy();
gl.scene.traverse(o=>{if(o.isMesh&&o.material){if(o.material.map)o.material.map.anisotropy=maxAniso;o.material.envMapIntensity=L.env;}});
const box=new T.Box3().setFromObject(gl.scene);
const c=box.getCenter(new T.Vector3()),sz=box.getSize(new T.Vector3());
gl.scene.position.sub(c);
rig.add(gl.scene);
function frame(){
  const w=canvas.clientWidth||600,h=canvas.clientHeight||400;
  renderer.setSize(w,h,false);cam.aspect=w/h;
  const dist=Math.max(sz.y*2.1,sz.z*1.45);
  cam.position.set(dist,dist*0.08,0);
  cam.lookAt(0,0,0);cam.updateProjectionMatrix();
}
frame();
new ResizeObserver(frame).observe(canvas);
const D2=T.MathUtils.degToRad;
const rotMin=D2(L.rotMin),rotMax=D2(L.rotMax);
let vel=0,drag=false,lastX=0,lastT=performance.now();
canvas.addEventListener('pointerdown',e=>{drag=true;lastX=e.clientX;canvas.classList.add('dragging');canvas.setPointerCapture(e.pointerId);lastT=performance.now();});
addEventListener('pointermove',e=>{if(drag){vel=T.MathUtils.clamp(vel+(e.clientX-lastX)*.005,rotMin,rotMax);lastX=e.clientX;lastT=performance.now();}});
addEventListener('pointerup',()=>{drag=false;canvas.classList.remove('dragging');});
const clock=new T.Clock();let idle=reduce?0:1;
renderer.setAnimationLoop(()=>{
  const t=clock.getElapsedTime();
  const idleT=performance.now()-lastT>2500;
  idle+=((reduce?0:idleT&&!drag?1:0)-idle)*.04;
  const osc=Math.sin(t*Math.PI*2/L.period)*D2(L.oscDeg)*idle;
  rig.rotation.y=T.MathUtils.clamp(osc+vel,rotMin,rotMax);
  renderer.render(scene,cam);
});
clearTimeout(stall);
prog(100,'READY');
setTimeout(()=>{loadEl.classList.add('done');pane.classList.add('pin3d-on');},300);
}catch(err){console.error(err);fail('Could not start the pin scene: '+(err&&err.message?err.message:err));}
};